import {createSelector} from 'reselect';

// Audit redux state
const auditReducerSelector = state => state.audit;

// Audit List
const auditSelector = createSelector(
    auditReducerSelector,
    auditReducer => auditReducer.get('payload')
);

// Audit is fetching
const auditIsFetchingSelector = createSelector(
    auditReducerSelector,
    auditReducer => auditReducer.get('isFetching')
);

// Audit error
const auditErrorSelector = createSelector(
    auditReducerSelector,
    auditReducer => auditReducer.get('error')
);

export {
    auditSelector,
    auditIsFetchingSelector,
    auditErrorSelector
};